require('./brokerConvenienceMiFIDTestStep3.scss');
require('./brokerConvenienceMiFIDTestStep3.override.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');

// @commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');

// components
const BrokerConvenienceMiFIDTestInvalidAnswersModal = require('mifid/components/brokerConvenienceMiFIDTestWizard/brokerConvenienceMiFIDTestInvalidAnswersModal/brokerConvenienceMiFIDTestInvalidAnswersModal');
const BrokerConvenienceMiFIDTestIncoherenceModal = require('mifid/components/brokerConvenienceMiFIDTestIncoherenceModal/brokerConvenienceMiFIDTestIncoherenceModal');

// @helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const { toFirstUppercase } = require('utilities/stringHelper');
const { shouldCoherenceControl } = require('mifid/utilities/mifidValidHelper');

// @actions
const BrokerConvenienceMiFIDTestStep3Action = require('mifid/actions/brokerConvenienceMiFIDTest/brokerConvenienceMiFIDTestStep3');
const BrokerConvenienceMiFIDTestAction = require('mifid/actions/brokerConvenienceMiFIDTest');

// @constants
const {
    THIRD_STEP,
    FOURTH_STEP,
    BROKER_CONVENIENCE_MIFID_TEST_MANUAL_ID,
    MYPROFILE_BROKER_URL,
    MYPROFILE_BROKER_CONSULT_MIFID_URL
} = require('constants/index');

const CLASS_NAME = 'broker-convenience-mifid-test-step-3';

class BrokerConvenienceMiFIDTestStep3 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            fetchedScore: false
        }
        this.handlePerformMiFIDTest = this.handlePerformMiFIDTest.bind(this);
        this.handleInvalidAnswersVerifyClick = this.handleInvalidAnswersVerifyClick.bind(this);
        this.handleInvalidAnswersModalCloseClick = this.handleInvalidAnswersModalCloseClick.bind(this);
    }

    componentDidMount() {
        if (shouldCoherenceControl()) {
            this.props.resetCurrentTestScoreStatus();
        }
    }

    buildInvalidAnswersModal() {
        const { immBrokerConvenienceMiFIDTest, renderStep0 } = this.props;

        const selectedStep = renderStep0 ? FOURTH_STEP : THIRD_STEP;
        const invalidAnswersModalVisible = immBrokerConvenienceMiFIDTest.getIn(['steps', selectedStep, 'invalidAnswersModalVisible']);
        const invalidAnswersModalTitle = immBrokerConvenienceMiFIDTest.getIn(['steps', selectedStep, 'invalidAnswersModalTitle']);
        const invalidAnswersModalMessage = immBrokerConvenienceMiFIDTest.getIn(['steps', selectedStep, 'invalidAnswersModalMessage']);

        return (
            <BrokerConvenienceMiFIDTestInvalidAnswersModal
                isVisible={invalidAnswersModalVisible}
                onVerifyClick={this.handleInvalidAnswersVerifyClick}
                onClose={this.handleInvalidAnswersModalCloseClick}
                title={invalidAnswersModalTitle}
                message={invalidAnswersModalMessage}
            />
        );
    }

    buildLegendBeforeQuestions() {
        if (this.props.isConsulting) {
            return <FormattedText value="broker-convenienceMifidConsultingTestAnswerFollowingQuestions" />
        } else {
            return <FormattedText value="broker-convenienceMifidTestAnswerFollowingQuestions" />
        }
    }

    buildRows() {
        const {
            immBrokerConvenienceMiFIDTest,
            onChangeProductExperience,
            isConsulting,
            renderStep0
        } = this.props;
        const selectedStep = renderStep0 ? FOURTH_STEP : THIRD_STEP;
        const immBrokerConvenienceMiFIDTestStep = immBrokerConvenienceMiFIDTest
            .get('steps')
            .get(selectedStep);
        const immProducts = immBrokerConvenienceMiFIDTestStep.get('products');

        return immProducts.map(immProduct => {
            const onChangeAnswer = answer =>
                onChangeProductExperience(immProduct.get('id'), answer);
            const options = immProduct.get('answers').map(immAnswer => {
                return (
                    <RadioButton
                        key={immAnswer.get('id')}
                        disabled={isConsulting}
                        value={immAnswer.get('id')}
                        className={`${CLASS_NAME}__product-options-radio`}
                    />
                );
            });

            let error = this.questionHasValidationError(
                immBrokerConvenienceMiFIDTestStep,
                immProduct
            );

            return (
                <tr key={immProduct.get('id')}>
                    <td className={`${CLASS_NAME}__products-column`}>
                        {immProduct.get('name')}
                    </td>
                    <td colSpan={3}>
                        <RadioButtonGroup
                            name={`product-${immProduct.get('id')}`}
                            idPrefix={`product-${immProduct.get('id')}`}
                            onChange={onChangeAnswer}
                            selectedValue={immProduct.get('answer')}
                            errorState={error}
                        >
                            {options}
                        </RadioButtonGroup>
                    </td>
                </tr>
            );
        });
    }

    buildTable() {
        return (
            <table className={`${CLASS_NAME}__products-table`}>
                <thead>
                    <tr>
                        <th className={`${CLASS_NAME}__products-column`}>
                            <FormattedText value="broker-convenienceMifidTestProduct" />
                        </th>
                        <th className={`${CLASS_NAME}__products-options-column`}>
                            <FormattedText value="broker-convenienceMifidTestTwoOrMore" />
                        </th>
                        <th className={`${CLASS_NAME}__products-options-column`}>
                            <FormattedText value="broker-convenienceMifidTestOnlyOne" />
                        </th>
                        <th className={`${CLASS_NAME}__products-options-column`}>
                            <FormattedText value="broker-convenienceMifidTestNone" />
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {this.buildRows()}
                </tbody>
            </table>
        );
    }

    buildValidationError() {
        let error = this.stepHasValidationError();
        let errorSection;
        if (error) {
            errorSection = (
                <div className="broker-convenience-mifid-test-wizard__error-message">
                    <FormattedText value="consultMiFID-validationGenericError" />
                </div>
            );
        }
        return errorSection;
    }

    handleInvalidAnswersModalCloseClick() {
        this.props.onInvalidAnswersModalCloseClick();
    }

    handleInvalidAnswersVerifyClick() {
        this.props.onInvalidAnswersVerifyClick();
    }

    handlePerformMiFIDTest() {
        const productName = undefined; // @hardcoded
        const productUrl = undefined; // @hardcoded
        const productId = BROKER_CONVENIENCE_MIFID_TEST_MANUAL_ID; // @hardcoded (franco.montenegro) temporal id, must be confirmed
        const continuationUrl = MYPROFILE_BROKER_URL;

        this.props.onStartConvenienceMiFIDTest(
            this.props.history,
            productName,
            productUrl,
            productId,
            continuationUrl,
            {
                isManualTest: true
            }
        );
    }

    buildIncoherenceControlModalContent(productsArray) {
        const { immBrokerConsultMiFID } = this.props;
        const immPreviousTest = immBrokerConsultMiFID.get('questions').toArray();
            const notHiredProducts = [],
            hiredOnceProducts = [],
            hiredMoreThanOnceProducts = [];
        const step3QuestionsIdArray = productsArray.map(product => product.get('id'));
        step3QuestionsIdArray.forEach(id => {
            const previousQuestion = immPreviousTest.find((question) => question.get('id') === id)
            const indexOfAnswer = !!previousQuestion && previousQuestion.getIn(['respuestasArray', 'respuestasArray']).indexOf(
                previousQuestion.getIn(['respuestasArray', 'respuestasArray']).toArray().find((answer) => answer.get('seleccionado')==='S')
            );
            const description = !!previousQuestion && productsArray.find(product => product.get('id') === id).get('name');
            if(indexOfAnswer === 0){
                hiredMoreThanOnceProducts.push(<div>{description}</div>);
            } else if(indexOfAnswer === 1){
                hiredOnceProducts.push(<div>{description}</div>);
            } else{
                notHiredProducts.push(<div>{description}</div>);
            }
        });
        return(
            <div>
                { !!notHiredProducts &&
                    <div className={`${CLASS_NAME}__coherence-modal-not-hired-product`}>
                        <FormattedText value="broker-convenienceMifidTestIncoherenceModalStep3NoHiredLabel"/>
                        {notHiredProducts}
                    </div>
                }
                { !!hiredOnceProducts &&
                    <div className={`${CLASS_NAME}__coherence-modal-hired-once-product`}>
                        <FormattedText value="broker-convenienceMifidTestIncoherenceModalStep3HiredOnceLabel"/>
                        {hiredOnceProducts}
                    </div>
                }
                { !!hiredMoreThanOnceProducts &&
                    <div className={`${CLASS_NAME}__coherence-modal-hired-more-than-once-product`}>
                        <FormattedText value="broker-convenienceMifidTestIncoherenceModalStep3HiredMoreThanOnceLabel"/>
                        {hiredMoreThanOnceProducts}
                    </div>
                }
            </div>
        );
    }

    buildIncoherenceControlModal() {
        const {
            immBrokerConvenienceMiFIDTest,
            renderStep0,
            onCheckIncoherences,
            immBrokerConsultMiFID,
            onContinueWithIncoherences,
        } = this.props;
        const selectedStep = renderStep0 ? FOURTH_STEP : THIRD_STEP;
        const showModal = immBrokerConvenienceMiFIDTest.getIn(['steps', selectedStep, 'showCoherenceModal']);
        const productsArray = immBrokerConvenienceMiFIDTest.getIn(['steps', selectedStep, 'products']).toArray();
        const modalContent = this.buildIncoherenceControlModalContent(productsArray);
        return(
            <BrokerConvenienceMiFIDTestIncoherenceModal
                showModal={showModal}
                finishStep={true}
                modalContent={modalContent}
                checkIncoherences={onCheckIncoherences}
                continueWithIncoherences={onContinueWithIncoherences}
                immBrokerConsultMiFID={immBrokerConsultMiFID}
            />
        );
    }

    questionHasValidationError(immFirstStep, immProduct) {
        return (
            !immFirstStep.get('valid') && immFirstStep.get('validated') && !immProduct.get('valid')
        );
    }

    stepHasValidationError() {
        const { immBrokerConvenienceMiFIDTest, renderStep0 } = this.props;
        const selectedStep = renderStep0 ? FOURTH_STEP : THIRD_STEP;
        const immFirstStep = immBrokerConvenienceMiFIDTest.get('steps').get(selectedStep);
        return !immFirstStep.get('valid') && immFirstStep.get('validated');
    }

    render() {
        const { actions, cancelButton, nextButton, isConsulting, getCurrentTestScore, renderStep0, immBrokerConvenienceMiFIDTest} = this.props;
        let className;
        let footer;
        const selectedStep = renderStep0 ? FOURTH_STEP : THIRD_STEP;
        if (isConsulting) {
            className = 'broker-convenience-mifid-test-step-3';
            footer = (
                <footer className="broker-convenience-mifid-test-step-3__footer">
                    <div className="broker-convenience-mifid-test-step-3__footer-buttons">
                        <OKButton
                            modifier="ghost"
                            leftIcon="icon-anterior"
                            onClick={this.props.actions.handlePrevClick}
                        >
                            {toFirstUppercase(formatText('buttonsActions-previous'))}
                        </OKButton>
                    </div>
                    <div className="broker-convenience-mifid-test-step-3__footer-buttons">
                        <OKButton
                            modifier="secondary"
                            rightIcon="icon-siguiente"
                            to={MYPROFILE_BROKER_CONSULT_MIFID_URL}
                        >
                            <FormattedText value="broker-convenienceMifidTestConsultTestBackButton" />
                        </OKButton>
                    </div>
                </footer>
            );
        }
        return (
            <div className={className}>
                <WizardStep
                    actions={actions}
                    cancelButton={!isConsulting && cancelButton}
                    nextButton={nextButton}
                    position="middle"
                >
                    {this.buildInvalidAnswersModal()}
                    <h4 className={`${CLASS_NAME}__title`}>
                        <FormattedText value="broker-convenienceMifidTestExperienceAsInvestor" />
                    </h4>
                    <p className={`${CLASS_NAME}__info`}>
                        {this.buildLegendBeforeQuestions()}
                    </p>

                    <p className={`${CLASS_NAME}__info ${CLASS_NAME}__info-bold`}>
                        <FormattedText value="broker-convenienceMifidTestRecruitingFrecuencyOrCurrentPositions" />
                    </p>

                    {this.buildTable()}
                    {this.buildValidationError()}
                    {this.buildIncoherenceControlModal()}
                    {footer}
                </WizardStep>
            </div>
        );
    }
}

BrokerConvenienceMiFIDTestStep3.propTypes = {
    history: PropTypes.object.isRequired,
    immBrokerConvenienceMiFIDTest: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    onChangeProductExperience: PropTypes.func.isRequired,
    cancelButton: PropTypes.bool,
    nextButton: PropTypes.bool,
    isConsulting: PropTypes.bool,
    onStartConvenienceMiFIDTest: PropTypes.func.isRequired,
    onInvalidAnswersVerifyClick: PropTypes.func.isRequired,
    onInvalidAnswersModalCloseClick: PropTypes.func.isRequired,
    renderStep0: PropTypes.bool.isRequired
};

BrokerConvenienceMiFIDTestStep3.defaultProps = {
    cancelButton: true,
    nextButton: true,
    isConsulting: false
};

module.exports.constructor = BrokerConvenienceMiFIDTestStep3;
module.exports.BrokerConvenienceMiFIDTestStep3 = connect(
    state => ({
        immBrokerConvenienceMiFIDTest: state.brokerConvenienceMiFIDTest,
        immBrokerConsultMiFID: state.brokerConsultMiFID,
    }),
    {
        onChangeProductExperience: BrokerConvenienceMiFIDTestStep3Action.changeProductExperience,
        onStartConvenienceMiFIDTest: BrokerConvenienceMiFIDTestAction.start,
        onInvalidAnswersModalCloseClick: BrokerConvenienceMiFIDTestStep3Action.closeInvalidAnswersModal,
        onInvalidAnswersVerifyClick: BrokerConvenienceMiFIDTestStep3Action.verifyAnswer,
        onCheckIncoherences: BrokerConvenienceMiFIDTestStep3Action.checkIncoherences,
        onContinueWithIncoherences:BrokerConvenienceMiFIDTestStep3Action.continueWithIncoherences,
        getCurrentTestScore: BrokerConvenienceMiFIDTestAction.getCurrentTestScore,
        resetCurrentTestScoreStatus: BrokerConvenienceMiFIDTestAction.resetCurrentTestScoreStatus,
    }
)(withRouter(BrokerConvenienceMiFIDTestStep3));
